<ng-container *ngIf="loading">
  <ng-container *ngIf="errorMessage">
    <div class="error">{{errorMessage}}</div>
  </ng-container>
  <ng-container *ngIf="!errorMessage">
    <div class="cities">
      <ng-container *ngIf="citiesLoading === 2">
        <div class="city-outer" *ngIf="cities.length > 0">
          <!-- <select class="select" [(ngModel)]="selectedMenu" (change)="onChange($event.target.value)" name="sel2">
            <option class="option" [value]="i" *ngFor="let m of menu; let i = index">{{m.name}}</option>
          </select> -->
          <!-- <div class="city" [ngClass]="activeCityId ? '' : 'reset'" (click)="resetFilters()">Все объекты</div> -->
          <div>
            <div class="select" (click)="showAll()">
              <span>{{selectedValue}}</span>
              <span class="arrow-down"></span>
            </div>
            <div *ngIf="showValues">
              <div *ngFor="let m of menu; let i = index">
                <div class="option" (click)="selectedValueBtn(m.id)">{{m.name}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="city-outer city-outer-count" *ngIf="cities.length > 0">
          <div class="count">{{objects.length}}</div>
        </div>
        <div class="city-outer" *ngFor="let city of cities">
          <div class="city" (click)="setCity(city)" [ngClass]="city.active ? 'active' : ''">
            <span>{{city.name}}</span>
            <span class="count">{{city.livingComplexCount}}</span>
          </div>
        </div>

        <div class="button-logs" (click)="downloadReport()">
            <span>Отчет</span>
          </div>
        <div class="clearfix"></div>
      </ng-container>
      <ng-container *ngIf="citiesLoading == 1">
        <div class="loading"></div>
      </ng-container>
    </div>
    <div class="objects">
      <div class="object" *ngFor="let object of objects; trackBy:trackByObject; let i = index">
        <ng-container *ngIf="object.id !== 1">
          <app-object [object]="object" [gallery]="false"></app-object>
        </ng-container>
      </div>
    </div>
  </ng-container>
</ng-container>
<ng-container *ngIf="!loading">
  <div class="loading"></div>
</ng-container>
